function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#lab_flask_svg__clip0_75_4981)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.611 11.48L9.136 4.882V1.728h1.04V0H3.828v1.73h1.048v3.154L.392 11.48a1.574 1.574 0 00-.072 1.666c.146.258.361.474.625.624.263.15.563.23.87.23h10.368c.307 0 .608-.08.872-.231.263-.151.48-.367.625-.626a1.579 1.579 0 00-.072-1.67l.004.007zm-.55 1.343a.972.972 0 01-.366.364c-.153.088-.329.134-.508.134H1.816c-.18 0-.356-.046-.51-.134a.973.973 0 01-.367-.366.922.922 0 01.043-.976l-.003.003 4.595-6.767V1.727h2.853v3.356l4.59 6.767a.904.904 0 01.041.98l.003-.005v-.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.772 7.205H5.004l-3.442 5.073a.163.163 0 00-.008.175c.03.05.086.084.15.085h10.368c.03 0 .06-.008.087-.023a.167.167 0 00.063-.062.16.16 0 00-.007-.175v.001L8.773 7.205z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lab_flask_svg__clip0_75_4981"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

var SvgLabFlask = function SvgLabFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLabFlask;